import { formatCalendarDate } from '../../../Calendar.utils'

function getCalendarRelieveDayEmptyTargetHint({ nextFreeDay, t }) {
  if (nextFreeDay.isFailed) {
    return { isFull: false, text: t('Calendar.LoadCheckFailedKey') }
  }

  return nextFreeDay.date
    ? null
    : { isFull: false, text: t('Calendar.RelieveDayNoFreeDayKey') }
}

export function getCalendarRelieveDayTargetHint({
  day,
  locale,
  nextFreeDay,
  selectedCount,
  t,
  targetDate,
  targetLoad,
}) {
  if (!targetDate) {
    return getCalendarRelieveDayEmptyTargetHint({ nextFreeDay, t })
  }

  if (targetDate === day) {
    return { isFull: true, text: t('Calendar.MoveAnotherDayKey') }
  }

  if (targetLoad.isFailed) {
    return { isFull: false, text: t('Calendar.LoadCheckFailedKey') }
  }

  if (!targetLoad.dayLoad) {
    return null
  }

  const used = targetLoad.dayLoad.follow_up_count + selectedCount

  return {
    isFull: used >= targetLoad.dayLoad.limit,
    text: t('Calendar.RelieveDayTargetLoadKey', {
      date: formatCalendarDate({ date: targetDate, locale }),
      limit: targetLoad.dayLoad.limit,
      used,
    }),
  }
}
